var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.formContainer},[_c('app-heading',{attrs:{"title":_vm.title}}),_vm._v(" "),(_vm.isMounted)?_c('user-form'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }